import * as brandColors from '../enums/brand_colors.js';

// TODO: Make this into a vue component
export default class Themes {
  constructor(userIsStaff, userIsSuperuser) {
    this.storedTheme = localStorage.getItem('theme');
    this.theme = this.getPreferredTheme(userIsStaff, userIsSuperuser);
    this.setTheme(this.theme);

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      if (this.storedTheme !== 'light' || this.storedTheme !== 'dark') {
        this.setTheme(this.theme);
      }
    });

    window.addEventListener('DOMContentLoaded', () => {
      this.showActiveTheme(this.theme);

      document.querySelectorAll('[data-bs-theme-value]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const theme = toggle.getAttribute('data-bs-theme-value');
          localStorage.setItem('theme', theme);
          this.setTheme(theme);
          this.showActiveTheme(theme);
        });
      });
    });

    this.brand_colors = brandColors;
  }

  /*!
   * Color mode toggler for Bootstrap's docs (https://getbootstrap.com/)
   * Copyright 2011-2022 The Bootstrap Authors
   * Licensed under the Creative Commons Attribution 3.0 Unported License.
   */

  getPreferredTheme(userIsStaff, userIsSuperuser) {
    if (!userIsStaff || !userIsSuperuser) {
      return 'light';
    }
    if (this.storedTheme) {
      return this.storedTheme;
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  // eslint-disable-next-line class-methods-use-this
  setTheme(theme) {
    // default to light mode
    if (theme === 'auto' && window.matchMedia('(prefers-color-scheme: light)').matches) {
      document.documentElement.setAttribute('data-bs-theme', 'light');
    } else {
      document.documentElement.setAttribute('data-bs-theme', theme);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  showActiveTheme(theme) {
    const btnToActive = document.querySelector(`[data-bs-theme-value="${theme}"]`);

    document.querySelectorAll('[data-bs-theme-value]').forEach((element) => {
      element.classList.remove('active');
    });

    if (btnToActive) btnToActive.classList.add('active');
  }
}
